import { treeViewAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

export default defineSlotRecipe({
  slots: treeViewAnatomy.keys(),
});
